export const publicUrl = (path: string) =>
  (process as any).env.PUBLIC_URL + path;
export const homeUrl = "/";
export const creditsUrl = "/credits";
export const boardPattern = "/board/:epd*";
export const boardUrl = (epd?: string) =>
  `/board${epd ? "/" + encodeURI(epd.replace(/ /g, "_")) : ""}`;
export const dashboardUrl = "/dashboard";
export const loginUrl = "/login";
export const userProfilePattern = "/:id(user_\\w+)";
export const userProfileUrl = (id: string) => `/${id}`;
export const challengePattern = "/:id(chlg_\\w+)";
export const challengeUrl = (id: string) => `/${id}`;
export const gamePattern = "/:id(game_\\w+)";
export const gameUrl = (id: string) => `/${id}`;
